<template>
    <div class="container">
        <el-card class="box-card" v-if="!isAuthenticated">
            <div slot="header" class="clearfix">
                <span class="text-bold h3">Identificación de Personal</span>
            </div>

            <employee-auth
                @auth-response="onAuthResponse"
                mode="code"
                button-text="Continuar"
            />
        </el-card>

        <el-card class="box-card" v-if="isAuthenticated && isConfirmOrder">
            <div slot="header" class="clearfix">
                <span class="text-bold h3">Confirmar la venta</span>
            </div>
            <div class="text-left">
                <p class="lead">
                    <span class="text-bold">Fecha</span> {{ order.date }}
                </p>

                <div class="table-responsive">
                    <table class="table table-striped">
                        <tr>
                            <th style="width: 50%">Cliente:</th>
                            <td>
                                {{ order.employee.profiles.first_name }}
                                {{ order.employee.profiles.first_surname }}
                                {{ order.employee.profiles.second_surname }}
                            </td>
                        </tr>
                        <tr>
                            <th>Email Empleado:</th>
                            <td>{{ order.employee.email }}</td>
                        </tr>
                        <tr>
                            <th>Monto Total:</th>
                            <td>{{ order.total | currency }}</td>
                        </tr>
                    </table>
                </div>
            </div>

            <employee-auth
                @auth-response="onAuthResponse($event, 1)"
                @cancel="cancelOrder"
                :method="cancelOrder"
                mode=""
                :employee="isAuthenticated"
                button-text="Confirmar Orden"
                :icon="isLoading ? 'el-icon-loading' : ''"
                :disabled="isLoading"
                :show-cancel-button="false"
            />
        </el-card>

        <product-selection
            v-if="isAuthenticated && !isConfirmOrder"
            @add-order="processOrder"
            @cancel-order="cancelOrder"
            :employee-id="isAuthenticated.id"
            :user-id="isAuthenticated.user_id"
        >
        </product-selection>
    </div>
</template>

<script>
import moment from "moment";
import EmployeeAuth from "./EmployeeAuth.vue";
import ProductSelection from "./ProductSelection.vue";
import { OrderStore } from "../OrderStore";

export default {
    name: "OrderSection",
    props: {
        msg: String,
    },
    components: {
        EmployeeAuth,
        ProductSelection,
    },
    data() {
        return {
            isAuthenticated: false,
            isConfirmOrder: false,
            order: {},
            isLoading: false,
            OrderStore,
        };
    },
    methods: {
        getCreditLimit() {
            return axios
                .get(
                    `${API_URL}/employees/${this.isAuthenticated.id}/limit_credit`
                )
                .then(({ data }) => data);
        },

        onAuthResponse(userData, isConfirmation) {
            this.isLoading = true;

            if (!userData) {
                this.isLoading = false;
                this.$notify({
                    title: "Error",
                    message: "credenciales incorrectas",
                    type: "error",
                });
            }

            if (!isConfirmation) {
                this.onAuthSuccess(userData);
            }

            this.confirmOrder();
        },

        async onAuthSuccess(user) {
            this.isAuthenticated = user;
            this.$notify({
                title: "Success",
                message: "Empleado correcto",
                type: "success",
            });

            this.creditLimit = await this.getCreditLimit();
        },

        processOrder(order) {
            this.order = order;
            this.isConfirmOrder = true;
        },

        addOrder() {
            const order = this.order;
            const form = {
                date: moment().format("YYYY-MM-DD"),
                employee_id: this.isAuthenticated.id,
                shop_id: this.$store.state.user.id,
                subtotal: parseInt(order.subtotal),
                discount: order.discount,
                total: order.total,
                status: 0,
            };

            axios
                .post(`${API_URL}/orders`, form)
                .then(() => {
                    this.$notify({
                        title: "Success",
                        message: "Orden agregada",
                        type: "success",
                    });
                    this.onOrderSucess(this.order);
                })
                .catch(({ response }) => {
                    const message = response.data.status
                        ? response.data.status.message
                        : "fallo al agregar la orden";
                    this.$notify({
                        title: "Error",
                        message,
                        type: "error",
                    });
                });
        },

        cancelOrder() {
            this.cancelConfirmation();
            this.isAuthenticated = false;
        },

        getDiscount(orderData) {
            return axios
                .post(`${API_URL}/orders`, orderData)
                .then(({ data }) => data);
        },

        confirmOrder() {
            if (!this.validateOrder(this.creditLimit)) {
                this.isLoading = false;
                this.$notify({
                    title: "Error",
                    message: "La orden excede el balance del empleado",
                    type: "error",
                });
                this.resetForm();
            }

            this.addOrder();
        },

        validateOrder(credit) {
            return credit.balance > this.order.subtotal;
        },

        onOrderSucess(order) {
            this.resetForm();
            this.$store.dispatch("setLastOrder", order);
            this.$router.push("order-success");
        },

        cancelConfirmation() {
            this.isConfirmOrder = false;
        },

        resetForm() {
            this.isAuthenticated = false;
            this.isConfirmOrder = false;
            this.order = {};
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
    margin: 40px 0 0;
}
ul {
    list-style-type: none;
    padding: 0;
}
li {
    display: inline-block;
    margin: 0 10px;
}
a {
    color: #42b983;
}

.container {
    margin-top: 50px;
}
</style>
